var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-temporarily d-flex\njustify-content-center align-items-center section-container",class:{'dark':_vm.skinType}},[_vm._v(" 暂无数据 ")])}
var staticRenderFns = []

export { render, staticRenderFns }